
export default {
  namespaced: true,
};
